{
  "version": 1,
  "asset_id": "63f879c3-fe6f-41d7-aa6c-3b0b933ab75d",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/63f879c3-fe6f-41d7-aa6c-3b0b933ab75d/buyukcekmece-isyeri-1.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/63f879c3-fe6f-41d7-aa6c-3b0b933ab75d/buyukcekmece-isyeri-1.jpg",
  "original_filename": "buyukcekmece-isyeri-1.jpg",
  "size": 661105,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T07:24:05Z"
}
